export default "__VITE_ASSET__3dcd602e__"